import React from "react";
import { connect } from "react-redux";
import WinRmUsernameField from "./WinRmUsernameField";
import WinRmPasswordField from "./WinRmPasswordField";
import CentralCredentialsField from "./CentralCredentialsField";
import DomainField from "./DomainField";
import DomainSetField from "./DomainSetField";
import WinrmHttpsField from "./WinrmHttpsField";

function WinRmConnectionFieldset({ disabled }) {
    return (
        <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-ssh">
            <DomainSetField/>
            <DomainField/>
            <CentralCredentialsField disabled={disabled} />
            <div className="row modal-v2-auth-grid">
                <div className="col-md-6 modal-v2-auth-col">
                    <WinRmUsernameField />
                </div>
                <div className="col-md-6 modal-v2-auth-col">
                    <WinRmPasswordField />
                </div>
            </div>
            <div className="col-12 modal-v2-auth-col">
                <WinrmHttpsField  disabled={disabled} />
            </div>
                               
                               
                            
        </fieldset>
    )
}

export default connect()(WinRmConnectionFieldset);
